/**
 * The shape this client sends to POST /api/answers, in one place.
 *
 * Every answer carries the format id and the config version it was collected
 * under, so a later config fix can never rewrite what an earlier participant
 * actually saw. Value goes as text; the client does not decide a column type.
 */
export function toAnswerPayload({ item, answer, configVersion, beepId = null }) {
  const text = typeof answer?.text === 'string' ? answer.text.trim() : ''
  const value = answer?.value

  return {
    item_id: item.item_id,
    // null on day 0. The server upserts on (participant, item, beep).
    beep_id: beepId,
    response_format: item.response_format,
    config_version: configVersion ?? null,
    value: value === null || value === undefined || value === '' ? null : String(value),
    free_text: text === '' ? null : text,
  }
}

/**
 * Server answers come back as text; rehydrate them into the {value, text} shape.
 * Day-0 state returns these. A beep payload returns only an `answered` flag per
 * item, not the value, so reopening a beep re-asks rather than pre-filling —
 * which is honest, and the save is an upsert either way.
 */
export function fromAnswerRow(row) {
  if (!row) return null
  return {
    value: row.value ?? null,
    text: row.free_text ?? '',
  }
}
